/* DOMNO. - mobile side menu: account, track, returns, market modal, Trustpilot
 * 12 Sep 2026, rev 20
 *
 * Bottom of the mobile navigation drawer:
 *
 *     LOG IN / REGISTER  o     ->    (signed in: YOUR ACCOUNT, no dot)
 *     TRACK ORDER              ->
 *     RETURN OR EXCHANGE       ->
 *     flag  GBP <sym>          ->    <- same row style; opens the market modal
 *
 * REV 10 (Dom): the utility rows sit tighter than the category links above (10px padding
 * against the theme's 12px) so they read as the sub menu, and the currency row has the same
 * arrow as the rows around it instead of a chevron - one row style, no odd one out.
 * REV 11 (Dom): those rows a step smaller too, 13px against the theme's 17px links.
 * REV 12 (Dom): the drawer header carried "D." in Montserrat. Reverted in rev 13.
 * REV 13 (Dom): the full wordmark is back, top left, at the header's own 35px. The red
 * caption under Log in is gone; in its place a small red dot after the words, the same dot
 * the header puts on the person icon (signed out only, same as there). Rows closer: 7px.
 * REV 14 (Dom): wordmark down to 30px; the dot tucked in to 4px from the words, sitting on
 * the text's centre line so it reads as part of the label.
 * REV 15: landing on a screen after Shopify login. The track page sends people to Shopify's
 * own login; its return_to is a bare "/" and cannot carry a query string, so the page leaves
 * sessionStorage dp_reopen_to=<screen> behind. This file loads on every page: when the
 * customer lands back signed in with that flag set, it waits for the drawer (domno-portal.js
 * reopens it off the dp_reopen breadcrumb), opens it itself if that has not happened, and calls
 * dpGo(<screen>). One-shot: the flag is cleared the moment it is read.
 * REV 16 (Dom): the Trustpilot block is now the footer's, exactly - same sizes, same weights,
 * same ink colour, the Trustpilot wordmark drawn rather than typed. The grey 12px sub-line
 * "looked fake". Source: snippets/domno-trustpilot.liquid.
 * REV 17 (Dom): "too big" at footer size in a 330px drawer - scaled to 85%: 17px / 100 / 12px / 63.
 * REV 18 (Dom): the sub menu sat too far under CLOTHING once its rows tightened. The theme's
 * tier-1 list keeps 12px of bottom padding; cut to 4px, so Clothing-to-Log in is ~25px text
 * to text - a touch more than the 24px between the two category links, a step more than the
 * 14px between the sub rows. Reads as one list with a breath, not a gap.
 * REV 19: landAfterLogin hands 'saved' to domno-saved.js (window.dpOpenSaved) instead of
 * dpGo, because the portal's own dpGo does not know that panel until saved.js has wrapped it.
 * REV 20: the red dot after LOG IN / REGISTER is gone. domno-saved.js now puts the star and a
 * red numbered badge on that row (and a Saved row under it), the same marker as the header.
 *     [ Trustpilot 4.8 ]             <- alone at the bottom
 *
 * The social icons and Our Reviews are removed from the drawer on the way past.
 *
 * ---- REV 5: the CRAFTD-style market modal ------------------------------------------
 * Dom picked the "no rule" version: the flag row sits under Trustpilot with no divider, and
 * opens a centred modal with the DOMNO logo, SHIPPING TO, a country+currency picker and one
 * UPDATE button.
 *
 * IT IS ENTIRELY SHOPIFY'S OWN DATA. Nothing here is a hardcoded country list:
 *   - the list comes from `/?section_id=country-selector`, the theme's own section, which
 *     renders {{ localization.available_countries }}. 237 countries, with each one's currency.
 *   - the current country comes from the theme's own `input[name="country_code"]`.
 *   - selecting one sets that input and submits the theme's own {% form 'localization' %},
 *     which already carries return_to. Shopify sets the market and reloads.
 * So markets added or removed in admin appear here with no code change, and no app or Plus
 * plan is involved.
 *
 * THAT FETCH IS ALSO WHAT DOM WAS COMPLAINING ABOUT. The theme's own picker renders ONE option
 * and lazy-loads the other 236 on first open, into a `position:static` listbox with no
 * max-height, inside the drawer's scrolling column - so it shoved the page down and left no way
 * out but scrolling back up. We fetch the same endpoint and put the result in a fixed modal with
 * its own scroll and a search box. 237 rows is unusable without the search.
 *
 * NO BENEFIT CLAIMS. CRAFTD print "No Import Charges" in this modal. DOMNO has a market called
 * "None PDDP", so that claim is FALSE for some customers and they would find out at the door.
 * Per-market copy has to be written and checked before any such line goes in here.
 *
 * ---- REV 6 --------------------------------------------------------------------------
 * Two fixes from Dom: the double divider under Return or exchange, and a bare drawer header.
 * Both are explained at the code that fixes them.
 *
 * ---- why JS and not Liquid ----------------------------------------------------------
 * The drawer is not in the DOM at page load. It is cloned from
 * <script class="mobile-navigation-drawer-template"> inside <main-navigation> the first time the
 * menu is opened, so anything appended at render time is thrown away. The Liquid behind it is
 * snippets/main-nav-links-mobile.liquid - 18KB of shared theme code that themeFilesUpsert can
 * only replace WHOLE, which is how the 10 Sep drift bugs happened.
 *
 * Loaded from snippets/domno-portal-boot.liquid, which passes the signed-in state down as a data
 * attribute - this file has no Liquid in it and cannot ask Shopify who the customer is.
 *
 * SAFE TO DELETE: remove the one <script> line in domno-portal-boot.liquid.
 */
(function () {
  'use strict';

  var me = document.currentScript;
  var SIGNED_IN = !!(me && me.getAttribute('data-signed-in') === '1');
  var TRACK_URL = (me && me.getAttribute('data-track-url')) || '/pages/track-your-order';
  var RETURNS_FALLBACK = 'https://returns.domno.com';

  /* ---- opening OUR portal, not Shopify's -------------------------------------------
     The account icon in the header is <button class="header-account-link">, and its entire
     onclick is "add .open to #dp-overlay". Both account rows go through the same three lines,
     so the menu never dumps anyone on Shopify's native /account page. If that button's
     behaviour changes, change openPortal() with it - the copy is by hand. */
  function openPortal() {
    var overlay = document.getElementById('dp-overlay');
    if (!overlay) return false;
    closeMobileNav();
    document.body.appendChild(overlay);
    overlay.style.zIndex = '2147483647';
    overlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  function closeMobileNav() {
    var t = document.querySelector('button.mobile-nav-toggle');
    if (t && document.body.classList.contains('reveal-mobile-nav')) t.click();
  }

  function fallbackUrl() {
    if (SIGNED_IN) return window.DP_ACCOUNT_URL || '/account';
    return window.DP_LOGIN_URL || '/account/login';
  }

  function returnsUrl() {
    try {
      if (typeof window.dpReturnsUrl === 'function') return window.dpReturnsUrl();
    } catch (e) {}
    return RETURNS_FALLBACK;
  }

  /* Country code to flag. The regional-indicator block starts at U+1F1E6 for A, so each letter
     maps to its own symbol and the pair renders as one flag - no image assets. */
  function flagOf(code) {
    if (!code || !/^[A-Za-z]{2}$/.test(code)) return '';
    var c = code.toUpperCase();
    return String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65) +
           String.fromCodePoint(0x1F1E6 + c.charCodeAt(1) - 65);
  }

  /* Shopify gives us "United Kingdom (GBP <sym>)" with a non-breaking space before the symbol.
     CRAFTD's format is "United Kingdom | <sym> GBP", so split it once, here. */
  function parseCountry(text) {
    var t = (text || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^(.*?)\s*\(([A-Za-z]{3})\s*([^)]*)\)$/);
    if (!m) return { name: t, cur: '', sym: '' };
    return { name: m[1].trim(), cur: m[2].toUpperCase(), sym: (m[3] || '').trim() };
  }
  function longLabel(c) { return c.cur ? c.name + ' | ' + c.sym + ' ' + c.cur : c.name; }
  function shortLabel(c) { return c.cur ? c.cur + ' ' + c.sym : c.name; }

  var CHEVRON =
    '<svg class="dpnav__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
    'aria-hidden="true" focusable="false"><path d="M20 8.5 12.5 16 5 8.5" ' +
    'stroke="currentColor" stroke-width="1.5"/></svg>';
  var TICK =
    '<svg class="dpmk__tick" width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
    'aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7" ' +
    'stroke="currentColor" stroke-width="1.8"/></svg>';

  /* ---- styles ----------------------------------------------------------------------
     Square corners throughout, because a customer sees this. The theme carries a site-wide
     `body, ..., span, button, input, label { text-transform: uppercase !important }` which
     inherits into everything - including a modal appended to <body> - so anything that should
     be sentence case says so explicitly, on the element AND its children. */
  var CSS = [
    /* No dividers anywhere in this block (Dom, rev 8) - the hairlines were fighting the
       clean nav links above, and the one over the currency row looked worst of all. The rows
       are separated by their own padding instead (7px since rev 13), and the groups by margin. */
    '.dpnav__row{display:flex;align-items:center;justify-content:space-between;gap:12px;',
      'margin:0 20px;padding:7px 0;border-top:0;',
      'font-family:Helvetica,Arial,sans-serif;font-size:13px;font-weight:400;line-height:22.4px;',
      'text-transform:uppercase;color:#171717;text-decoration:none;cursor:pointer;',
      'background:none;border-left:0;border-right:0;border-bottom:0;width:calc(100% - 40px);',
      'text-align:left;-webkit-appearance:none;appearance:none;border-radius:0;}',
    '.dpnav__row:active{opacity:.55;}',
    '.dpnav__arw{font-size:15px;line-height:1;color:#171717;flex:0 0 auto;}',
    /* The dot after LOG IN / REGISTER: the header's .dp-dot, 7px #ff0000 with a 2px white ring,
       but flowing after the words rather than pinned to a corner, and lifted a touch so it
       reads as a badge, not a full stop. Own class - .dp-dot is position:absolute !important. */
    '.dpnav__dot{display:inline-block;width:7px;height:7px;border-radius:50%;background:#ff0000;',
      'border:2px solid #fff;box-sizing:content-box;margin-left:4px;vertical-align:middle;',
      'position:relative;top:-2px;}',

    /* REV 9 (11 Sep, Dom picked "A with the perfect padding"): the hole between CLOTHING and
       LOG IN. The theme gives the mobile nav a 40px margin-bottom, and its tier-1 list 12px
       of padding, so with the link's own 12px and our row's 16px there was ~80px of nothing
       under the last category. Closing the 40 to 2 leaves the same rhythm as everywhere else
       in the block (roughly 42px text-to-text, which is what the harness showed). The two
       selectors match the theme's own exactly, so this wins by coming later, not by weight. */
    '.mobile-navigation-drawer .navigation{margin-bottom:2px;}',
    '.mobile-navigation-drawer .navigation .navigation__tier-1{padding-bottom:4px;}',

    /* Trustpilot - last in the drawer, and with the dividers gone it is the 34px margin
       alone that separates it from the rows above. Do not shrink it without checking. */
    '.dpnav__tp{margin:34px 20px 26px;padding:0;border-top:0;}',
    /* rev 16: these values are the footer widget's, verbatim (snippets/domno-trustpilot.liquid):
       Excellent 20px/700, stars 118 wide, 9px gap, "Rated 4.8 / 5 on" 14px/400 in the text
       colour with the Trustpilot wordmark at 74 wide. Change them there and here together. */
    '.dpnav__tp a{display:inline-flex;flex-direction:column;align-items:flex-start;gap:9px;',
      'text-decoration:none;color:#171717;line-height:1;',
      'font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;}',
    '.dpnav__tp a,.dpnav__tp span,.dpnav__tp b{text-transform:none !important;}',
    '.dpnav__tprow{display:inline-flex;align-items:center;gap:9px;}',
    '.dpnav__tpex{font-size:17px;font-weight:700;letter-spacing:-.2px;}',
    '.dpnav__tpsub{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:400;color:#171717;}',
    '.dpnav__tpsub svg{width:63px;}',
    '.dpnav__tpsub svg{display:block;}',

    /* The market row. Rev 7: Dom wanted this in the list with Track order and Return or
       exchange rather than orphaned under Trustpilot, so it copies .dpnav__row exactly -
       same 14px, same padding, same (absent) border - and only the contents differ (flag +
       currency on the left; rev 10 gave it the same arrow as the other rows - it opens a
       modal rather than going anywhere, but one row style reads better than an odd one out).
       Sentence case is forced because the theme's site-wide
       `text-transform:uppercase !important` would otherwise shout the currency symbol. */
    '.dpnav__mkt{display:flex;align-items:center;justify-content:space-between;gap:12px;',
      'margin:0 20px;padding:7px 0;border-top:0;',
      'font-family:Helvetica,Arial,sans-serif;font-size:13px;font-weight:400;line-height:22.4px;',
      'color:#171717;cursor:pointer;background:none;border-left:0;border-right:0;',
      'border-bottom:0;width:calc(100% - 40px);text-align:left;border-radius:0;',
      '-webkit-appearance:none;appearance:none;}',
    '.dpnav__mkt,.dpnav__mkt *{text-transform:none !important;}',
    '.dpnav__mkt:active{opacity:.55;}',
    '.dpnav__mktleft{display:inline-flex;align-items:center;gap:9px;min-width:0;}',
    '.dpnav__mktfl{font-size:17px;line-height:1;flex:0 0 auto;}',
    '.dpnav__chev{color:#6b7280;flex:0 0 auto;}',

    /* the logo in the drawer header. Absolutely positioned so it cannot disturb the theme's
       own space-between layout of back-arrow / title / close. At top level the back arrow and
       title are visibility:hidden, so the left side is empty and the logo has it to itself;
       once a submenu opens they take over and the logo gets out of the way. */
    '.dpnav__logolink{position:absolute;left:20px;top:50%;transform:translateY(-50%);',
      'display:block;line-height:0;z-index:2;}',
    /* Rev 14: the wordmark at 30px - a touch under the header's 35px (rev 13), which Dom
       found slightly big in the 51px drawer header. (Rev 8-11 were 24px; rev 12 a "D.") */
    '.dpnav__logo{display:block;height:30px;width:auto;}',
    '.mobile-navigation-drawer--child-open .dpnav__logolink{display:none;}',

    /* ---- the modal ---- */
    '.dpmk{position:fixed;inset:0;z-index:2147483646;display:none;',
      'font-family:Helvetica,Arial,sans-serif;}',
    '.dpmk.open{display:block;}',
    '.dpmk,.dpmk *{text-transform:none !important;border-radius:0 !important;',
      'box-sizing:border-box;}',
    '.dpmk__bg{position:absolute;inset:0;background:rgba(0,0,0,.5);}',
    '.dpmk__box{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);',
      'width:calc(100% - 40px);max-width:380px;background:#fff;padding:26px 22px 22px;}',
    '.dpmk__x{position:absolute;top:10px;right:10px;background:none;border:0;font-size:24px;',
      'line-height:1;color:#171717;cursor:pointer;padding:6px;-webkit-appearance:none;',
      'appearance:none;}',
    '.dpmk__logo{display:block;max-width:132px;height:auto;margin:0 auto 22px;}',
    '.dpmk__word{display:block;text-align:center;font-size:16px;font-weight:700;',
      'letter-spacing:.2em;color:#171717;margin:0 0 22px;}',
    '.dpmk__lab{display:block;text-align:center;font-size:11px;font-weight:700;',
      'letter-spacing:.16em;text-transform:uppercase !important;color:#6b7280;margin:0 0 9px;}',
    '.dpmk__sel{display:flex;align-items:center;gap:10px;width:100%;padding:14px;',
      'border:1px solid #d5d9de;background:#fff;font-family:inherit;font-size:14px;',
      'color:#171717;cursor:pointer;text-align:left;-webkit-appearance:none;appearance:none;}',
    '.dpmk__selfl{font-size:18px;line-height:1;flex:0 0 auto;}',
    '.dpmk__selnm{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
    '.dpmk__cta{display:block;width:100%;margin-top:22px;padding:17px 14px;background:#171717;',
      'color:#fff;border:0;font-family:inherit;font-size:13px;font-weight:700;',
      'letter-spacing:.12em;text-transform:uppercase !important;cursor:pointer;',
      '-webkit-appearance:none;appearance:none;}',
    '.dpmk__cta[disabled]{opacity:.45;cursor:default;}',

    /* the country list, over the modal */
    '.dpmk__list{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);',
      'width:calc(100% - 44px);max-width:370px;max-height:74vh;background:#fff;',
      'box-shadow:0 12px 44px rgba(0,0,0,.3);display:none;flex-direction:column;}',
    '.dpmk__list.open{display:flex;}',
    '.dpmk__srch{flex:0 0 auto;padding:12px;border-bottom:1px solid #dfe3e8;}',
    '.dpmk__srch input{width:100%;padding:12px;border:1px solid #d5d9de;background:#fff;',
      'font-family:inherit;font-size:15px;color:#171717;-webkit-appearance:none;appearance:none;}',
    /* the ONLY scrolling element - 237 countries have to scroll inside, not push the page */
    '.dpmk__opts{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;',
      'margin:0;padding:4px 0 8px;list-style:none;}',
    '.dpmk__opt{display:flex;align-items:center;gap:11px;width:100%;padding:13px 16px;',
      'background:none;border:0;text-align:left;font-family:inherit;font-size:15px;',
      'color:#171717;cursor:pointer;-webkit-appearance:none;appearance:none;}',
    '.dpmk__opt:active{background:#f4f5f7;}',
    '.dpmk__opt[aria-selected="true"]{font-weight:700;}',
    '.dpmk__optfl{font-size:18px;line-height:1;flex:0 0 auto;}',
    '.dpmk__optnm{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
    '.dpmk__tick{margin-left:auto;flex:0 0 auto;color:#171717;}',
    '.dpmk__msg{padding:22px 16px;text-align:center;font-size:14px;color:#6b7280;}'
  ].join('');

  function injectCss() {
    if (document.getElementById('dpnav-css')) return;
    var s = document.createElement('style');
    s.id = 'dpnav-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---- the market modal -------------------------------------------------------------- */
  var modal = null;      /* built once, reused */
  var theForm = null;    /* the theme's own localization <form> */
  var countries = null;  /* [{code,name,cur,sym}] once fetched */
  var chosen = null;     /* code picked in the modal, not yet applied */
  var currentCode = '';

  function closeModal() {
    if (!modal) return;
    modal.querySelector('.dpmk__list').classList.remove('open');
    modal.classList.remove('open');
    document.documentElement.style.overflow = '';
  }

  /* Set the theme's own hidden input and submit the theme's own form. Shopify does the rest. */
  function applyCountry(code) {
    if (!theForm || !code) return;
    var input = theForm.querySelector('input[name="country_code"]');
    if (!input) return;
    input.value = code;
    if (typeof theForm.requestSubmit === 'function') theForm.requestSubmit();
    else theForm.submit();
  }

  function byCode(code) {
    if (!countries) return null;
    for (var i = 0; i < countries.length; i++) {
      if (countries[i].code === code) return countries[i];
    }
    return null;
  }

  function paintSelected() {
    var c = byCode(chosen || currentCode);
    if (!c) return;
    modal.querySelector('.dpmk__selfl').textContent = flagOf(c.code);
    modal.querySelector('.dpmk__selnm').textContent = longLabel(c);
    var cta = modal.querySelector('.dpmk__cta');
    cta.disabled = !chosen || chosen === currentCode;
  }

  function renderOptions(filter) {
    var ul = modal.querySelector('.dpmk__opts');
    ul.innerHTML = '';
    if (!countries) return;
    var q = (filter || '').trim().toLowerCase();
    var shown = 0;
    for (var i = 0; i < countries.length; i++) {
      var c = countries[i];
      if (q && c.name.toLowerCase().indexOf(q) === -1 &&
               c.cur.toLowerCase().indexOf(q) === -1) continue;
      var sel = c.code === (chosen || currentCode);
      var li = document.createElement('li');
      li.className = 'dpmk__opt';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', sel ? 'true' : 'false');
      li.innerHTML = '<span class="dpmk__optfl">' + flagOf(c.code) + '</span>' +
                     '<span class="dpmk__optnm"></span>' + (sel ? TICK : '');
      /* textContent: the country name is Shopify's string, not ours. */
      li.querySelector('.dpmk__optnm').textContent = longLabel(c);
      li.addEventListener('click', (function (code) {
        return function () {
          chosen = code;
          modal.querySelector('.dpmk__list').classList.remove('open');
          paintSelected();
        };
      })(c.code));
      ul.appendChild(li);
      shown++;
    }
    if (!shown) {
      var m = document.createElement('li');
      m.className = 'dpmk__msg';
      m.textContent = 'No countries match that.';
      ul.appendChild(m);
    }
  }

  /* The theme's own section, rendering {{ localization.available_countries }}. Fetched once. */
  function loadCountries(then) {
    if (countries) { then(); return; }
    var ul = modal.querySelector('.dpmk__opts');
    ul.innerHTML = '<li class="dpmk__msg">Loading countries...</li>';
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + '?section_id=country-selector'
            : '/?section_id=country-selector')
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var opts = tpl.content.querySelectorAll('.custom-select__option');
        var list = [];
        for (var i = 0; i < opts.length; i++) {
          var code = opts[i].getAttribute('data-value');
          if (!code) continue;
          var p = parseCountry(opts[i].textContent);
          list.push({ code: code, name: p.name, cur: p.cur, sym: p.sym });
        }
        countries = list;
        then();
      })
      .catch(function () {
        ul.innerHTML = '<li class="dpmk__msg">Could not load the country list. ' +
                       'Please try again.</li>';
      });
  }

  function openList() {
    var list = modal.querySelector('.dpmk__list');
    var box = modal.querySelector('.dpmk__srch input');
    list.classList.add('open');
    box.value = '';
    loadCountries(function () {
      renderOptions('');
      var cur = modal.querySelector('.dpmk__opts [aria-selected="true"]');
      if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
    });
  }

  function buildModal() {
    var el = document.createElement('div');
    el.className = 'dpmk';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Choose your country and currency');
    el.innerHTML =
      '<div class="dpmk__bg" data-dpmk-close></div>' +
      '<div class="dpmk__box">' +
        '<button type="button" class="dpmk__x" aria-label="Close" data-dpmk-close>&times;</button>' +
        '<div class="dpmk__brandslot"></div>' +
        '<span class="dpmk__lab">Shipping to</span>' +
        '<button type="button" class="dpmk__sel">' +
          '<span class="dpmk__selfl"></span><span class="dpmk__selnm"></span>' + CHEVRON +
        '</button>' +
        '<button type="button" class="dpmk__cta">Update preferences</button>' +
      '</div>' +
      '<div class="dpmk__list">' +
        '<div class="dpmk__srch">' +
          '<input type="search" inputmode="search" autocomplete="off" ' +
            'placeholder="Search countries" aria-label="Search countries">' +
        '</div>' +
        '<ul class="dpmk__opts" role="listbox"></ul>' +
      '</div>';

    /* The real logo, cloned from the header so it can never drift from it. Falls back to the
       wordmark if the header has no image (a page that renders a text logo). */
    var slot = el.querySelector('.dpmk__brandslot');
    var headerLogo = document.querySelector('img.logo__image');
    if (headerLogo) {
      var img = headerLogo.cloneNode(false);
      img.className = 'dpmk__logo';
      img.removeAttribute('itemprop');
      img.removeAttribute('loading');
      img.alt = headerLogo.getAttribute('alt') || 'DOMNO.';
      slot.appendChild(img);
    } else {
      var w = document.createElement('span');
      w.className = 'dpmk__word';
      w.textContent = 'DOMNO.';
      slot.appendChild(w);
    }

    el.addEventListener('click', function (ev) {
      if (ev.target.hasAttribute && ev.target.hasAttribute('data-dpmk-close')) closeModal();
    });
    el.querySelector('.dpmk__sel').addEventListener('click', openList);
    el.querySelector('.dpmk__cta').addEventListener('click', function () {
      if (chosen && chosen !== currentCode) applyCountry(chosen);
      else closeModal();
    });
    el.querySelector('.dpmk__srch input').addEventListener('input', function () {
      renderOptions(this.value);
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal();
    });
    document.body.appendChild(el);
    return el;
  }

  function openModal() {
    if (!modal) modal = buildModal();
    chosen = null;
    /* Seed the picker from the theme's own current country before the list has loaded, so the
       modal is never blank while the fetch is in flight. */
    if (!byCode(currentCode)) {
      var seedName = modal.getAttribute('data-seed') || '';
      var p = parseCountry(seedName);
      modal.querySelector('.dpmk__selfl').textContent = flagOf(currentCode);
      modal.querySelector('.dpmk__selnm').textContent = longLabel(p);
      modal.querySelector('.dpmk__cta').disabled = true;
    } else {
      paintSelected();
    }
    modal.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }

  /* ---- rows -------------------------------------------------------------------------- */
  var ARROW = '<span class="dpnav__arw" aria-hidden="true">&rarr;</span>';

  function linkRow(href, label) {
    var a = document.createElement('a');
    a.className = 'dpnav__row';
    a.href = href;
    a.innerHTML = '<span>' + label + '</span>' + ARROW;
    return a;
  }

  /* Opens the portal instead of navigating, but stays a real <a> with a working href so a
     dead-JS page, middle-click and screen readers all still behave. */
  function portalRow(label) {
    var a = linkRow(fallbackUrl(), label);
    a.addEventListener('click', function (ev) {
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
      if (openPortal()) ev.preventDefault();
    });
    return a;
  }

  function marketTrigger(selector) {
    var form = selector.closest('form');
    var input = form && form.querySelector('input[name="country_code"]');
    if (!form || !input) return null;
    theForm = form;
    currentCode = input.value || '';

    var btnLabel = selector.querySelector('.custom-select__btn span');
    var seed = btnLabel ? btnLabel.textContent : '';
    var p = parseCountry(seed);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dpnav__mkt';
    b.setAttribute('aria-label', 'Change country and currency');
    b.innerHTML = '<span class="dpnav__mktleft">' +
                    '<span class="dpnav__mktfl" aria-hidden="true"></span>' +
                    '<span class="dpnav__mkttx"></span>' +
                  '</span>' + ARROW;
    b.querySelector('.dpnav__mktfl').textContent = flagOf(currentCode);
    b.querySelector('.dpnav__mkttx').textContent = shortLabel(p);
    b.addEventListener('click', function () {
      if (!modal) modal = buildModal();
      modal.setAttribute('data-seed', seed);
      openModal();
    });
    return b;
  }

  /* Five full green stars + the Trustpilot wordmark. Same drawing as
     snippets/domno-trustpilot.liquid - one green rect per star with the star knocked out in
     white on top. No grey rect and no partial star: 4.8 rounds to five full, which is how
     Trustpilot itself renders it. IDs suffixed -n so they cannot collide with the footer's. */
  var STARS =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 96" width="100" style="display:block">' +
    '<defs><path id="tpSn" fill="#fff" d="M48,64.7L62.6,61l6.1,18.8L48,64.7z M81.6,40.4H55.9L48,16.2l-7.9,24.2H14.4l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L81.6,40.4z"/></defs>' +
    '<rect width="96" height="96" fill="#00B67A"/><rect x="104" width="96" height="96" fill="#00B67A"/>' +
    '<rect x="208" width="96" height="96" fill="#00B67A"/><rect x="312" width="96" height="96" fill="#00B67A"/>' +
    '<rect x="416" width="96" height="96" fill="#00B67A"/>' +
    '<use href="#tpSn"/><use href="#tpSn" x="104"/><use href="#tpSn" x="208"/><use href="#tpSn" x="312"/><use href="#tpSn" x="416"/></svg>';

  /* The Trustpilot wordmark, the footer's drawing, green star included. */
  var TPWORD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1132.8 278.2" width="74" style="display:block"><path fill="currentColor" d="M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z"/><path fill="#00B67A" d="M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"/><path fill="#005128" d="M194.7 181.8l-7.2-22.3-51.8 37.6z"/></svg>';

  function trustpilot() {
    var tp = document.createElement('div');
    tp.className = 'dpnav__tp';
    tp.innerHTML =
      '<a href="https://uk.trustpilot.com/review/domno-vintage.com" target="_blank" rel="noopener" ' +
      'aria-label="DOMNO. rated Excellent 4.8 out of 5 on Trustpilot">' +
      '<span class="dpnav__tprow"><span class="dpnav__tpex">Excellent</span>' + STARS + '</span>' +
      '<span class="dpnav__tpsub"><span>Rated <b style="font-weight:700;">4.8</b> / 5 on</span>' + TPWORD + '</span>' +
      '</a>';
    return tp;
  }

  /* ---- wiring ------------------------------------------------------------------------ */
  function decorate(drawer) {
    if (!drawer || drawer.querySelector('.dpnav__row')) return;
    var foot = drawer.querySelector('.mobile-navigation-drawer__footer');
    if (!foot) return;
    injectCss();

    /* The logo, top left, cloned from the header so it can never drift from the real one.
       position:relative is set here rather than in the stylesheet so we are not writing a rule
       against one of the theme's own class names. */
    var hdr = drawer.querySelector('.navigation__mobile-header');
    if (hdr && !hdr.querySelector('.dpnav__logolink')) {
      var src = document.querySelector('img.logo__image');
      if (src) {
        hdr.style.position = 'relative';
        var a = document.createElement('a');
        a.className = 'dpnav__logolink';
        a.href = '/';
        a.setAttribute('aria-label', 'DOMNO. home');
        var lg = src.cloneNode(false);
        lg.className = 'dpnav__logo';
        lg.removeAttribute('itemprop');
        lg.removeAttribute('loading');
        lg.removeAttribute('width');
        lg.removeAttribute('height');
        lg.alt = src.getAttribute('alt') || 'DOMNO.';
        a.appendChild(lg);
        hdr.insertBefore(a, hdr.firstChild);
      }
    }

    /* The theme's picker is found FIRST, because the market row now belongs in the list
       below and has to be built before the block is inserted.
       Hide the WHOLE .header-localization, not just the .custom-select inside it. Hiding only
       the picker left the form behind at 1px tall, which drew a SECOND hairline under Return
       or exchange - the double divider Dom spotted. A display:none form still submits
       programmatically and its hidden input is still readable, which is all we use it for. */
    var loc = foot.querySelector('.header-localization');
    var selector = loc && loc.querySelector('country-selector');
    if (loc && selector) loc.style.display = 'none';

    /* 1. The rows, in one block at the top of the drawer footer. */
    var rows = document.createDocumentFragment();
    if (SIGNED_IN) {
      rows.appendChild(portalRow('Your account'));
    } else {
      /* rev 20: no dot here any more - domno-saved.js decorates this row with the star badge */
      rows.appendChild(portalRow('Log in / Register'));
    }
    rows.appendChild(linkRow(TRACK_URL, 'Track order'));
    rows.appendChild(linkRow(returnsUrl(), 'Return or exchange'));
    if (selector) {
      var trig = marketTrigger(selector);
      if (trig) rows.appendChild(trig);
    }
    foot.insertBefore(rows, foot.firstChild);

    /* 2. Our Reviews out. The whole .inline-menu wrapper goes, not just the link, or an empty
          span is left behind holding its own top border. */
    var inline = foot.querySelector('.inline-menu');
    if (inline) inline.remove();

    /* 3. Socials out - already in the footer. */
    var social = foot.querySelector('ul.social');
    if (social) social.remove();

    /* 4. Trustpilot, appended last so it sits alone at the very bottom. */
    foot.appendChild(trustpilot());
  }

  function scan() {
    var d = document.querySelectorAll('.mobile-navigation-drawer');
    for (var i = 0; i < d.length; i++) decorate(d[i]);
  }

  /* ---- land on a screen after login (rev 15) ------------------------------------ */
  function landAfterLogin() {
    if (!SIGNED_IN) return;
    var to = '';
    try { to = sessionStorage.getItem('dp_reopen_to') || ''; if (to) sessionStorage.removeItem('dp_reopen_to'); } catch (e) {}
    if (!/^[a-z]+$/.test(to)) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (to === 'saved') {
        if (typeof window.dpOpenSaved === 'function') { clearInterval(iv); window.dpOpenSaved(); }
        else if (tries > 40) clearInterval(iv);
        return;
      }
      var overlay = document.getElementById('dp-overlay');
      if (overlay && !overlay.classList.contains('open') && tries >= 4) openPortal();
      if (overlay && overlay.classList.contains('open') && typeof window.dpGo === 'function') {
        clearInterval(iv);
        try { window.dpGo(to); } catch (e) {}
        return;
      }
      if (tries > 40) clearInterval(iv);
    }, 250);
  }

  function start() {
    landAfterLogin();
    scan();
    /* The drawer is cloned in on first open and can be rebuilt, so watch rather than run once. */
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
